module.exports = __webpack_public_path__ + "static/media/Banner_Governe_sua_empresa_através_dos_padrões_e_boas_práticas_de_ITIL_e_COBIT-06.14255e25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Governe_sua_empresa/Banner_Governe_sua_empresa_através_dos_padrões_e_boas_práticas_de_ITIL_e_COBIT-06.png
// module id = 107
// module chunks = 0